import { getContext, setContext } from 'svelte';
import { resolveComponentClasses, } from './theme';
import { createThemeStore } from '../stores/themeStore';
import { getAllKnownLocales, localeStore, } from '../utils/locale';
import { buildFormatters } from '../utils/format';
import { derived } from 'svelte/store';
const settingsKey = Symbol();
function createLocaleStores(settings) {
    if (settings.locale && settings.localeSettings && settings.format) {
        return {
            locale: settings.locale,
            localeSettings: settings.localeSettings,
            format: settings.format,
        };
    }
    let allLocales = getAllKnownLocales(settings.localeFormats);
    let locale = localeStore(settings.forceLocale, settings.fallbackLocale);
    let localeSettings = derived(locale, ($locale) => {
        let settings = allLocales[$locale];
        if (settings) {
            return settings;
        }
        return {
            ...allLocales.en,
            locale: $locale,
        };
    });
    return {
        locale,
        localeSettings,
        format: derived(localeSettings, buildFormatters),
    };
}
export function settings(settings) {
    let lightThemes = settings.themes?.light ?? ['light'];
    let darkThemes = settings.themes?.dark ?? ['dark'];
    let currentTheme = 
    // In some cases, `settings` is called again from inside a component. Don't create a new theme store in this case.
    settings.currentTheme ??
        createThemeStore({
            light: lightThemes,
            dark: darkThemes,
        });
    let localeStores = createLocaleStores(settings);
    return setContext(settingsKey, {
        ...settings,
        themes: {
            light: lightThemes,
            dark: darkThemes,
        },
        currentTheme,
        componentSettingsCache: {},
        ...localeStores,
    });
}
let FALLBACK_SETTINGS = null;
function getFallbackSettings() {
    FALLBACK_SETTINGS = FALLBACK_SETTINGS ?? {
        currentTheme: createThemeStore({ light: ['light'], dark: ['dark'] }),
        componentSettingsCache: {},
        ...createLocaleStores({}),
    };
    return FALLBACK_SETTINGS;
}
export function getSettings() {
    // in a try/catch to be able to test w/o svelte components
    try {
        return getContext(settingsKey) ?? getFallbackSettings();
    }
    catch (error) {
        return getFallbackSettings();
    }
}
export function resolveComponentSettings(settings, name) {
    const { classes: themeClasses, ...defaultProps } = settings?.components?.[name] ?? {};
    const classes = resolveComponentClasses(themeClasses);
    const output = {
        defaults: (defaultProps ?? {}),
        classes,
    };
    return output;
}
export function getComponentSettings(name) {
    const settings = getSettings();
    const existing = settings.componentSettingsCache[name];
    if (existing) {
        return existing;
    }
    const output = resolveComponentSettings(settings, name);
    settings.componentSettingsCache[name] = output;
    return output;
}
